import { styled } from '@fluentui/react';
import { HorizontalBarChartLoadingAnimationBase } from './horizontal-bar-chart-loading-animation.base';
import { gethorizontalBarChartStyles } from './horizontal-bar-chart-loading-animation.styles';
// tslint:disable-next-line:max-line-length // we shouldn't let linters/prettier dictate our variable names
export const HorizontalBarChartLoadingAnimation = styled(HorizontalBarChartLoadingAnimationBase, gethorizontalBarChartStyles, undefined, {
    scope: 'HorizontalBarChartLoadingAnimation',
}, true);
//# sourceMappingURL=horizontal-bar-chart-loading-animation.js.map